module.exports = __webpack_public_path__ + "media/pdf/smp/Muster_SCHUFA-Vollauskunft-235056b619c8888a721fcfc86a4e2097.pdf";